import { OnboardingLayout } from '../components/onboarding/onboarding-layout';

const FunnelCreationPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <OnboardingLayout />
    </div>
  );
};

export default FunnelCreationPage;
